var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.791016,
    y: 0.887695,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#D9EBC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.083 7.08105C15.2766 8.72898 16.2062 9.71146 17.8223 9.81598V11.6695C16.8857 11.76 16.0653 11.4569 15.1111 10.8856V14.3521C15.1111 18.7559 10.2592 20.1321 8.30853 16.9756C7.05505 14.9444 7.82263 11.3803 11.8436 11.2374V13.192C11.5373 13.2407 11.2099 13.3174 10.9106 13.4184C10.0162 13.718 9.5092 14.279 9.65004 15.2684C9.92116 17.1637 13.4351 17.7246 13.1429 14.0212V7.08454H15.083V7.08105Z",
    fill: "#69A42E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokGreen);
export default __webpack_public_path__ + "static/media/tiktok_green.d098e31b59e04e1fa442235602439b4f.svg";
export { ForwardRef as ReactComponent };